import React from 'react';
import { PageState } from '../models/pageState';

export interface PagerProps extends PageState {
    children?: null;
}

export const Pager: React.FunctionComponent<PagerProps> = () => {
    return null;
}